import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CONTENT_BLOCK_FEATURE_KEY } from './keys';
import { EffectsModule } from '@ngrx/effects';
import { contentBlockReducer } from './reducers/content-block.reducer';
import { ContentBlockEffects } from './effects/content-block.effects';

@NgModule({
    imports: [StoreModule.forFeature(CONTENT_BLOCK_FEATURE_KEY, contentBlockReducer), EffectsModule.forFeature(ContentBlockEffects)],
})
export class ContentBlockStoreModule {}
